import useWindowSize from '@src/utils/useWindowSize';
import { useEffect, useState } from 'react';

const EXTRA_SPACE = 235;

const useChatsItemsSize = (
  chatsRef: React.RefObject<HTMLDivElement>,
  chatsSearchRef: React.RefObject<HTMLDivElement>
) => {
  const [, setChatsHeight] = useState<number>(0);
  const [chatsSearchHeight, setChatsSearchHeight] = useState<number>(0);

  const [, windowHeight] = useWindowSize();

  useEffect(() => {
    if (chatsRef?.current?.clientHeight) {
      const { clientHeight } = chatsRef.current;
      setChatsHeight(clientHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatsRef?.current?.clientHeight]);

  useEffect(() => {
    if (chatsSearchRef?.current?.offsetHeight) {
      const { offsetHeight } = chatsSearchRef.current;
      setChatsSearchHeight(offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatsSearchRef?.current?.offsetHeight]);

  return windowHeight - chatsSearchHeight - EXTRA_SPACE;
};

export default useChatsItemsSize;
